import {Tooltip, IconButton} from "@mui/material";
import {MaterialSymbol} from "react-material-symbols";

interface CloseIconUIProps {
  onClick: () => void;
}
export default function CloseIconUI({onClick}: CloseIconUIProps) {
  return (
    <Tooltip title="Close question" arrow>
      <IconButton
        onClick={onClick}
        sx={{
          position: "absolute",
          top: 12,
          left: 12,
          color: "primary.dark",
          zIndex: 10,
          backgroundColor: "primary.main",
        }}>
        <MaterialSymbol icon="arrow_back" size={20} weight={400} />
      </IconButton>
    </Tooltip>
  );
}
